import React from "react";
import {
  TabbedShowLayout,
  Tab,
  TopToolbar,
  Button,
  ShowProps,
} from "react-admin";
import SanitizedGrid from "components/SanitizedGrid";
import { Grid } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import Class from "./Class";
import { GetParam } from "utils/tools";
import ShowWrapper from "../../components/ShowWrapper";

const ShowActions = (props: any) => {
  const { history } = props;
  return (
    <TopToolbar>
      <Button
        onClick={() =>
          history.push(
            `/levels/${props.data?.id}?schoolId=${props.data?.schoolId}`
          )
        }
        label="Edit"
      >
        <EditIcon />
      </Button>
    </TopToolbar>
  );
};

const LevelShow = (props: ShowProps) => {
  const { id } = props;
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Levels", link: `/schools/${param.get("schoolId")}/show/1` },
    { title: id, link: "" },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        actions={<ShowActions history={props.history} />}
        {...props}
      >
        <SanitizedGrid container spacing={2}>
          <Grid item xs={12}>
            <TabbedShowLayout>
              <Tab label="Class">
                <Class {...props} />
              </Tab>
            </TabbedShowLayout>
          </Grid>
        </SanitizedGrid>
      </ShowWrapper>
    </>
  );
};

export default LevelShow;
